function macrotasks(timeout = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}
async function microtasks(count = 1) {
  for (let i = 0; i < count; i++) {
    await Promise.resolve();
  }
}
function executionOf(stuff) {
  stuff();
  return Promise.resolve();
}

export { executionOf, macrotasks, microtasks };
/*                              */
